import Questionnaire from "../sections/Questionnaire";

const icons = [
  {
    title: "weniger als 9 Meter",
    link: "weniger-9-meter",
    imgUrl: "/content/uploads/2018/08/tiefer-9m.png"
  },
  {
    title: "mehr als 9 Meter",
    link: "mehr-als-9-meter",
    imgUrl: "/content/uploads/2018/08/tiefer-9m.png"
  }
]

export function Brunnenwasser() {

  return (
    <Questionnaire question={"Wie tief ist der Wasserspiegel im Brunnen?"} icons={icons} />
  );
}